<div *ngIf="exampleArticles" class="container bg-white pv-40 mt-40">
    <div class="list-use-cases">
        <div class="d-flex justify-content-between align-items-center">
            <h3>
                Explore use cases
            </h3>
            <div class="d-flex align-items-center">
                <button *ngIf="false" class="btn btn-text text-500 mr-16">
                    <span class="material-icons-outlined">filter_list</span>
                    <span>Filters</span>
                </button>
                <div class="input-search">
                    <span class="material-icons-outlined">search</span>
                    <input [(ngModel)]="articlesFilterStr" class="input-no-borders" id="input_formula" type="text" placeholder="Search by name">
                </div>
            </div>
        </div>
        <div class="wrap-block-use-cases">
            <a *ngFor="let item of filteredArticles" [href]="item.articleUrl" target="_blank" class="block-use-cases">
                <div>
                    <img [src]="item.iconUrl" alt="">
                </div>
                <div class="wrap-info">
                    <span class="body-2">{{item.title}}</span>
                    <div class="list-tags">
                        <div class="tag tag-border mt-8">Tag1</div>
                        <div class="tag tag-border mt-8">Tag2</div>
                    </div>
                </div>
            </a>
        </div>
        <div *ngIf="filteredArticles.length < exampleArticles.length" class="d-flex justify-content-center">
            <button (click)="showMoreArticlesClick()" class="btn btn-text">Show more</button>
        </div>
    </div>
</div>
